// extracted by mini-css-extract-plugin
export default {"container":"Info_container__XvzTU","right":"Info_right__AsB5S","details":"Info_details__l8NUa","label":"Info_label__fnLkN"};